import axios from "axios";
import { AccountEntityPermission } from "../../types/model/EntityPermission/AccountEntityPermission";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/app/admin/entity-permissions/account`;

export const getAccountEntityPermissions = async (
  accountId?: number,
  entityId?: number
): Promise<AccountEntityPermission[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  return await axios
    .get<AccountEntityPermission[]>(BASE_URL, {
      params: {
        accountId,
        entityId,
      },
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    })
    .then((response) => response.data);
};